/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Status_CompromisedInputs */



/**
* | output |
* | --- |
* | "Compromised" |
*
* @param {Dashboard_Status_CompromisedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const dashboard_status_compromised = /** @type {((inputs?: Dashboard_Status_CompromisedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Status_CompromisedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скомпрометирован")
	return /** @type {LocalizedString} */ ("Compromised")
});